(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('IncentiveForm', IncentiveForm);

    IncentiveForm.$inject = ['$resource'];

    function IncentiveForm ($resource) {
        var resourceUrl =  '/api/getcurrentuser';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
